import { render, staticRenderFns } from "./RadioGroupForm.vue?vue&type=template&id=65f5fd94&"
import script from "./RadioGroupForm.vue?vue&type=script&lang=js&"
export * from "./RadioGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./RadioGroupForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports